const boldFileP = `${process.env.REACT_APP_BASE_CDN}/static/media/Sequel100Black45.woff2`;
const boldFileS = `${process.env.REACT_APP_BASE_CDN}/static/media/PSAGroupeHMISans-Bold.woff2`;
const lightFileS = `${process.env.REACT_APP_BASE_CDN}/static/media/PSAGroupeHMISans-Light.woff2`;
const normalFileS = `${process.env.REACT_APP_BASE_CDN}/static/media/PSAGroupeHMISans-Regular.woff2`;

export default {
  primary: {
    bold: {
      file: boldFileP,
      name: 'Sequel 100 Black'
    },
    lighter: {
      file: boldFileP,
      name: 'Sequel 100 Black'
    },
    normal: {
      file: boldFileP,
      name: 'Sequel 100 Black'
    }
  },
  secondary: {
    bold: {
      file: boldFileS,
      name: 'PSA Groupe HMI Sans Bold'
    },
    lighter: {
      file: lightFileS,
      name: 'PSA Groupe HMI Sans Lighter'
    },
    normal: {
      file: normalFileS,
      name: 'PSA Groupe HMI Sans'
    }
  }
};
